import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hp-pages-steps',
  templateUrl: './pages-steps.component.html',
  styleUrls: ['./pages-steps.component.css']
})
export class PagesStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
